export enum IconColor {
  DEFAULT = '#D8D3ED',
  WHITE = '#FFfFFF',
  RED = '#FF3F3F',
}
